import { render, staticRenderFns } from "./MensalidadesCancelados.vue?vue&type=template&id=68d36b19&scoped=true&"
import script from "./MensalidadesCancelados.vue?vue&type=script&lang=js&"
export * from "./MensalidadesCancelados.vue?vue&type=script&lang=js&"
import style0 from "./MensalidadesCancelados.vue?vue&type=style&index=0&id=68d36b19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d36b19",
  null
  
)

export default component.exports